import React, { Component } from 'react'
import { Container, Table, Button, Spinner, Modal } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers';
import axios from 'axios'
import { addCommaInNumber } from '../../helpers/function'
import CheckWeight from './CheckWeight';
function convertDate(inputDate) {
  let date = new Date(inputDate)
  let days = date.getDate()
  if (parseInt(days) < 10) {
    days = `0${days}`
  }
  let month = parseInt(date.getMonth()) + 1
  if (parseInt(month) < 10) {
    month = `0${month}`
  }
  let year = date.getFullYear()
  let outputDate = `${year}-${month}-${days}`
  return outputDate
}
function timeInterval(startDate, endDate) {
  var now = new Date(startDate);
  var then = new Date(endDate);
  var dayCount = 0;
  let dateArr = []
  dateArr.push(convertDate(startDate))
  while (now.setHours(1, 3, 3, 7) > then.setHours(1, 3, 3, 7)) {
    let newThen = then.setDate(then.getDate() + 1);
    dateArr.push(convertDate(newThen))
    dayCount++;
  }
  while (now.setHours(1, 3, 3, 7) < then.setHours(1, 3, 3, 7)) {
    let newNow = now.setDate(now.getDate() + 1);
    dateArr.push(convertDate(newNow))
    dayCount++;
  }
  var years = Math.floor(dayCount / 365);
  dayCount = dayCount - years * 365;
  var months = Math.floor(dayCount / 30);
  dayCount = dayCount - months * 30;
  var days = dayCount

  return dateArr
}

class FinancialWageTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listInComplete: false,
      inCompleteLoading: true,
      completedLoading: false,
      isHoliday: false,
      CompanyList: [],
      riceTypeIDAndName: [],
      data: [],
      renderData: [],
      officerData: [],
      modalExtracertificate: false,
      modalExtracertificateData: [],
      modalIndex: '-99',
      viewAllSurveyPromise: []
    }
    this.handleFilterChecker = this.handleFilterChecker.bind(this)
    this.handleChangeValue = this.handleChangeValue.bind(this)
    this.handleSaveData = this.handleSaveData.bind(this)
    this.handleModal = this.handleModal.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.handleExtraCertificateValue = this.handleExtraCertificateValue.bind(this)
    this.setDefaultTransportFare = this.setDefaultTransportFare.bind(this)
  }
  queryJobID = (jobIDArr) => {
    // console.log(jobIDArr)
    return axios.post(
      'https://backend1.riceinspections.com/testHB',
      {
        data: { 'arr': [...new Set(jobIDArr)] },
      })
  }
  // 
  queryRequestID = (requestIDArr) => {
    // console.log(jobID)
    return axios.post(
      'https://backend1.riceinspections.com/testHC',
      {
        data: { 'arr': [...new Set(requestIDArr)] },
      })
  }
  queryCheckWeight = (licenseIDArr) => {
    let licenseIDPromise = []

    licenseIDArr.map((id) => {
      licenseIDPromise.push(axios.post(
        'https://backend1.riceinspections.com/testCB',
        {
          data: { 'licenseID': id },
        }
      ))
    })
    return licenseIDPromise
  }
  reConstructRequestID = (requestID) => {
    let newRequestID = []
    if (Array.isArray(requestID)) {
      requestID.map((data) => {
        if (data) {
          if (Object.values(data)[0]['requestID'] == '26964' || Object.values(data)[0]['requestID'] == '19152' || Object.values(data)[0]['requestID'] == '19154') {
            // console.log(Object.values(data)[0]['requestID'])
            // console.log(Object.values(data)[0])
          }
          if (Object.values(data)[0]?.['description']) {
            let timeMin = ((Math.round((99 + Number.EPSILON) * 100) / 100))
            let timeMax = ((Math.round((0 + Number.EPSILON) * 100) / 100))
            Object.values(data)[0]['description'].map((dataForSum) => {
              if (dataForSum['Time']) {
                let arrMinMax = dataForSum['Time'].split('-')
                let min = ((Math.round((parseFloat(arrMinMax[0]) + Number.EPSILON) * 10000) / 10000))
                let max = ((Math.round((parseFloat(arrMinMax[1]) + Number.EPSILON) * 10000) / 10000))
                if (min < timeMin && min > 0) {
                  timeMin = min
                }
                if (max > timeMax) {
                  timeMax = max
                }
              }
            })
            timeMin = timeMin.toFixed(2)
            timeMax = timeMax.toFixed(2)
            if (timeMin == 99) {
              timeMin = '0.00'
            }
            if (timeMin.length < 4) {
              timeMin = `0${timeMin}`
            }
            if (timeMax.length < 4) {
              timeMax = `0${timeMax}`
            }

            newRequestID.push({
              ...Object.values(data)[0],
              Time: `${timeMin}-${timeMax}`
            })
          }
        }
      })
      return newRequestID

    }
  }
  renderDate(dateObj) {
    let dateParser = new Date(dateObj)
    let day = dateParser.getDate()
    let month = dateParser.getMonth() + 1
    let years = dateParser.getFullYear() + 543
    return `${day}/${month}/${years}`
  }

  calculateWage(start, end, chainID) {
    let firstPartStart = start?.split('.')[0]
    let secondPartStart = start?.split('.')[1]
    let firstPartStop = end?.split('.')[0]
    let secondPartStop = end?.split('.')[1]

    if (start) {
      if (firstPartStart.length != 2) {
        firstPartStart = `0${firstPartStart}`
        start = `${firstPartStart}.${secondPartStart}`
      }
      if (firstPartStop.length != 2) {
        firstPartStop = `0${firstPartStop}`
        end = `${firstPartStop}.${secondPartStop}`
      }
      if (start == end && (start != '00.00' && end != '00.00')) {
        return 1
      }
      if (start == '00.00' && end == '00.00') {
        return 0
      }
      if (start.length == 5 && end.length == 5) {
        let holiday = false
        let startHrInMin = (parseInt(start?.slice(0, 2)) * 60)
        let startMinInMin = (parseInt(start?.slice(start.length - 2, start.length)))
        let startMin = startHrInMin + startMinInMin
        let endMin = (parseInt(end?.slice(0, 2)) * 60) + (parseInt(end?.slice(end.length - 2, end.length)))
        // let total = Math.ceil((endMin - startMin)/60) * 0
        let total = 0
        let hrStart = parseInt(start.slice(0, 2))
        let hrEnd = parseInt(end.slice(0, 2))

        if (holiday) {
          if (hrStart <= 20) {
            total += 1
          }
          if (hrEnd >= 20) {
            if (parseInt(end.slice(2, 4)) > 0) {
              total += 1
            }
          }
        } else {
          if (hrStart <= 20) {
            total += 1
          }
          if (hrEnd >= 20) {
            if (hrEnd == 20) {
              if (parseInt(end.slice(2, 4)) > 0) {
                total += 1
              }
            } else {
              total += 1
            }
          }
        }
        if (this.excelRenderChain(chainID) != '') {
          total = 0
        }

        return total
      } else {
        return 0
      }
    }
  }
  calculateExtraWage(start, end, chainID, isHoliday, isWeekend) {
    let firstPartStart = start.split('.')[0]
    let secondPartStart = start.split('.')[1]
    let firstPartStop = end.split('.')[0]
    let secondPartStop = end.split('.')[1]
    if (firstPartStart.length != 2) {
      firstPartStart = `0${firstPartStart}`
      start = `${firstPartStart}.${secondPartStart}`
    }
    if (firstPartStop.length != 2) {
      firstPartStop = `0${firstPartStop}`
      end = `${firstPartStop}.${secondPartStop}`
    }
    if (start == end) {
      return 0
    }
    if (start.length == 5 && end.length == 5) {
      // let startHrInMin = (parseInt(start.slice(0, 2)) * 60)
      // let startMinInMin = (parseInt(start.slice(start.length - 2, start.length)))
      // let startMin = startHrInMin + startMinInMin
      // let endMin = (parseInt(end.slice(0, 2)) * 60) + (parseInt(end.slice(end.length - 2, end.length)))
      // let total = Math.ceil((endMin - startMin)/60) * 0
      let total = 0
      let hrStart = parseInt(start.slice(0, 2))
      let hrEnd = parseInt(end.slice(0, 2))
      let minEnd = parseInt(end.slice(3, 5))
      // console.log(isHoliday,hrStart,hrEnd,minEnd)

      if (isWeekend) {
        if (hrStart <= 7 && (hrEnd >= 18 && minEnd > 0)) {
          total += 300
        }
        if (hrStart <= 7 && (hrEnd > 18 && minEnd >= 0)) {
          total += 300
        }
        else if ((hrStart <= 7 && hrEnd <= 18)) {
          if (hrEnd == 18 && minEnd == 0) {
            total += 200
          } else if (hrEnd == 18 && minEnd > 0) {
            total += 300
          } else {
            total += 200
          }
        } else if (hrStart <= 7 && hrEnd <= 8) {
          if (hrEnd == 8 && minEnd == 0) {
            total += 100
          } else if (hrEnd == 8 && minEnd > 0) {
            total += 200
          } else {
            total += 100
          }
        } 
        else if ((hrStart >= 8 && hrStart <= 17) && (hrEnd > 18 && minEnd >= 0)) {
          total += 200
        } else if ((hrStart >= 8 && hrStart <= 17) && (hrEnd <= 18)) {
          if (hrEnd == 18 && minEnd == 0) {
            total += 100
          } else if (hrEnd == 18 && minEnd > 0) {
            total += 200
          } else {
            // console.log('count')
            total += 100
          }
        } else if ((hrStart >= 18 && hrStart <= 24) && (hrEnd <= 24)) {
          total += 100
        }

      } else {
        if (hrStart <= 7) {
          total += 100
        }
        if (hrEnd >= 18) {
          if (hrEnd == 18 && minEnd == 0) {
            total += 0
          } else {
            total += 100
          }
        }
      }
      //deprecate because misunderstand 
      // if (chainID == 'chain' || chainID == 'ต่อ') {
      //   total = 0
      // }

      return total
    }
  }
  getQuantity(data) {
    let sumQuant = 0
    let testQuant = 0
    data['description'].map((desData, idx) => {
      let listKeys = Object.keys(desData)
      // console.log(listKeys)
      
      if (listKeys.indexOf('LoaingType') != -1) {

        if (listKeys.indexOf('bagQuantity') != -1 && desData['bagQuantity'] > 0) {
          let quantityInWeigth = (parseFloat(desData['bagQuantity']) * parseFloat(desData['netWeight'])) / 1000
          if(data['jobID'] == '8028' ){
            console.log(desData['bagQuantity'],desData['netWeight'],quantityInWeigth, ((Math.round((quantityInWeigth + Number.EPSILON) * 100000))))

            // console.log(listKeys)
          }
          testQuant += (parseFloat(desData['bagQuantity']) * parseFloat(desData['netWeight']))/1000

          quantityInWeigth = ((Math.round((quantityInWeigth + Number.EPSILON) * 100)))

          sumQuant += quantityInWeigth


        } else if (listKeys.indexOf('Time') != -1) {
          if (desData['Time']) {
            if (data['jobID'] == '8028') {
              console.log(desData['Quantity'],desData['netWeight'],(parseFloat(desData['Quantity']) * parseFloat(desData['netWeight'])) *100)
              // (425 * 22.7) + (425*22.7)+(850*22.7)+(2100*9.09) + (1050*18.18) + (1700*11.35)+(850*22.7)+(2100*9.09)
              // console.log(desData)
              // console.log(listKeys)
            }
            testQuant += parseFloat(desData['Quantity']) * parseFloat(desData['netWeight'])/1000

            sumQuant += (parseFloat(desData['Quantity']) * parseFloat(desData['netWeight'])) /10

          }
        }
      }
    })
    // if(data['jobID'] == '8028'){
      // console.log(testQuant*100)
    // }



    sumQuant = sumQuant / 100
    return sumQuant
  }
  componentDidMount() {

    let endDate = this.props.history.location.state.endDate
    let startDate = this.props.history.location.state.startDate
    if (!endDate) {
      endDate = startDate
    }
    let dateArr = timeInterval(convertDate(startDate), convertDate(endDate))
    dateArr = [...new Set(dateArr)]

    let viewAllFinancialWageByDate = axios.post(
      'https://backend1.riceinspections.com/testHD',
      {
        data: { 'arr': dateArr },
      })
    let viewAllWageSheetByDate = axios.post(
      'https://backend1.riceinspections.com/testIB',
      {
        data: { 'arr': dateArr },
      }
    )

    let viewAllSurveyRequestSheetByDate = axios.post(
      'https://backend1.riceinspections.com/testHE',
      {
        data: { 'arr': dateArr },
      })

    let viewAllOfficer = axios.get(
      'https://backend1.riceinspections.com/testC',
    )
    let viewAllCompany = axios.get(
      'https://backend1.riceinspections.com/testD'
    )
    let viewAllSurveyPromise = fetch(`https://backend1.riceinspections.com/testBD`).then((res) => {
      return res.json()
    })

    Promise.all([viewAllFinancialWageByDate, viewAllOfficer, viewAllSurveyRequestSheetByDate, viewAllCompany, viewAllWageSheetByDate, viewAllSurveyPromise])
      .then((res) => {
        let jobIDArr = []
        let requestIDArr = []
        let snapValue = res[0].data
        // console.log(snapValue)
        viewAllSurveyRequestSheetByDate = res[2]['data']
        viewAllCompany = res[3]['data']
        viewAllWageSheetByDate = res[4]['data']
        viewAllSurveyPromise = res[5]

        Object.values(viewAllSurveyRequestSheetByDate).map((requestIDData) => {
          if (requestIDData) {
            Object.values(requestIDData).map((requestIDDataInside) => {
              jobIDArr.push(requestIDDataInside['requestID'])
              requestIDArr.push(requestIDDataInside['requestID'])
            })
          }
        })
        let checkWeight = {}
        Object.values(snapValue).map((checkWeightData, idx) => {
          jobIDArr.push(checkWeightData['requestID'])
          requestIDArr.push(checkWeightData['requestID'])
          if (checkWeightData['jobID'] == '7944') {
            console.log(checkWeightData)
          }
          checkWeight = {
            ...checkWeight,
            [checkWeightData['requestID']]: {
              ...CheckWeight[checkWeightData['requestID']],
              ...checkWeightData,
            }
          }
        })
        Promise.all([this.queryJobID(jobIDArr), this.queryRequestID(requestIDArr)]).then((resSec) => {
          let jobID = resSec[0]['data']
          let requestID = resSec[1]['data']
          viewAllOfficer = res[1].data
          requestID = this.reConstructRequestID(requestID)
          console.log(requestID)

          let finalData = {}
          let newJobID = []
          jobID.map((data) => {
            if (data) {
              newJobID.push(data)
            }
          })
          newJobID.map((data, idx) => {
            // console.log(data)
            if (data) {
              finalData = {
                ...finalData,
                [data['requestID']]: {
                  ...data,
                  ...requestID[idx],
                  ...checkWeight[data['requestID']],
                  officerID: data['officerID'],
                  Time: requestID[idx]['Time']
                }
              }
            }
          })
          // console.log(snapValue)
          console.log(finalData)
          let modifierFinalData = {}
          //add detail checkweight
          snapValue.map((data) => {

            let newDescription = finalData[data['requestID']]['description'].filter((o) => {
              return ((o['licenseID'] == data['licenseID']) && (o['subID'] == data['subID']))
            })
            if(data['licenseID'] != '99999999'){
              newDescription[0]['Quantity'] = data['bagQuantity']
              newDescription[0]['LoaingType'] = data['LoaingType']
  
            }


            if(data['requestID'] == '27063'){
              console.log(data)
              console.log(finalData[data['requestID']])
            }

            // modifierFinalData[data['requestID']] = {
            //   ...finalData[data['requestID']],
            //   description: newDescription
            // }

          })
          //add detail checkweight





          //
          let fareArray = {}
          Object.values(finalData).map((data, idx) => {
            if (Number.isInteger(parseInt(data['officerID'])) && parseInt(data['officerID']) > 100) {
              let index = 0
              data['officerID'] = Object.values(viewAllOfficer).filter((o, idx) => {
                if (o['ID'] == parseInt(data['officerID'])) index = idx
                return o['ID'] == parseInt(data['officerID'])
              })[0]?.['fName']
              data['officerID'] = `${index + 1}. ${data['officerID']}`
              data['officerIDNumber'] = data['officerID']
            }
            if (Number.isInteger(parseInt(data['officerID2'])) && parseInt(data['officerID2']) > 100) {
              let index = 0
              data['officerID2'] = Object.values(viewAllOfficer).filter((o, idx) => {
                if (o['ID'] == parseInt(data['officerID2'])) index = idx
                return o['ID'] == parseInt(data['officerID2'])
              })[0]?.['fName']
              data['officerID2'] = `${index + 1}. ${data['officerID2']}`
              data['officerID2Number'] = data['officerID']
            }

            let isFoundCompanyName = Object.values(viewAllCompany).filter(o => o['companyNameTH'] == data['companyID'])
            if (isFoundCompanyName.length > 0) {
              if (isFoundCompanyName[0]['companyTaxID']) {
                data['companyTaxID'] = isFoundCompanyName[0]['companyTaxID']
              }
            }

            data['quantity'] = this.getQuantity(data)
 

            let roundNumber = parseFloat(data['quantity'])
            roundNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)

            if(data['requestID'] == '27063'){
              console.log(roundNumber,data['quantity'])
            }
            data['quantity'] = roundNumber
            // let roundNumberWithComma = addCommaInNumber(roundNumber)
            data['sumWage'] = this.calculateWage(data['Time'].split('-')[0], data['Time'].split('-')[1], data['chainID'])
            data['sumWageBaht'] = this.calculateWageBaht(roundNumber)
            // console.log(new Date(data['shippingDate']).getDay())
            let isHoliday = false
            if (new Date(data['shippingDate']).getDay() == 0 || new Date(data['shippingDate']).getDay() == 6) {
              isHoliday = true
            }


            let isWeekend = false

            if (new Date(data['shippingDate']).getDay() == 0 || new Date(data['shippingDate']).getDay() == 6) {
              isWeekend = true
            }
            if(data['checkWeightID']  == '72270'){
              console.log(data)
            }

            data['sumExtraWage'] = this.calculateExtraWage(data['Time'].split('-')[0], data['Time'].split('-')[1], data['chainID'], isHoliday, isWeekend)
            if(data['checkWeightID']  == '72270'){
              console.log(data)
            }
            let isFoundSurvey = Object.values(viewAllSurveyPromise).filter(o => {
              let isFound = 0
              if (o['companyTaxID']) {
                let findCompany = o['companyTaxID'].filter(oo => oo.companyTax == data['companyTaxID'])
                if (findCompany.length > 0) {
                  isFound = 1
                }
              }
              if ((o['surveyNameTH'] == data['surveyLocateName']) && (isFound > 0)) {
                return true
              }
            })
            if (isFoundSurvey.length > 0) {

              let transportFare = isFoundSurvey[0]['companyTaxID'].filter(o => o['companyTax'] == data['companyTaxID'])
              if (transportFare[0]['fare'].length > 0) {
                data['transportFare'] = parseInt(transportFare[0]['fare'])
              } else {
                data['transportFare'] = 0
              }
            } else {
              data['transportFare'] = 0
            }

            // data['transportFare'] = 0
            fareArray[`${idx}`] = data['transportFare']
            data['isExtraCertificate'] = false
            data['extraCertificate'] = []

            let isFoundExtraCertificate = data['description'].filter(o => o.licenseID == 9999999999999)
            if (isFoundExtraCertificate.length > 0) {
              isFoundExtraCertificate.map((descriptionData) => {
                Object.keys(descriptionData).map((descriptionDataKey) => {
                  if (descriptionDataKey.indexOf('vehicleName') != -1) {
                    // console.log(descriptionData[descriptionDataKey])
                    data['isExtraCertificate'] = true
                    data['extraCertificate'].push({
                      description: descriptionData[descriptionDataKey],
                      value: 0
                    })
                    // console.log(descriptionData)
                  }
                })
              })
            }
            // <td style={{ width: '2.7%', fontSize: '13px' }}><input id='sumWageBaht' onChange={(e)=>{this.handleChangeValue(data['jobID'],e)}} style={{ width: '100%' }} defaultValue={this.calculateWageBaht(roundNumber)}></input></td>
            // <td style={{ width: '2.7%', fontSize: '13px' }}><input id='sumExtraWage' onChange={(e)=>{this.handleChangeValue(data['jobID'],e)}} style={{ width: '100%' }} defaultValue={this.calculateExtraWage(data['Time'].split('-')[0], data['Time'].split('-')[1], data['chainID'], this.state.isHoliday)}></input></td>
            // <td style={{ width: '2.7%', fontSize: '13px' }}><input id='transportFare' onChange={(e)=>{this.handleChangeValue(data['jobID'],e)}} style={{ width: '100%' }}></input></td>

            // viewAllCompany data['companyID']
          })

          // console.log(fareArray)
          // console.log(finalData)
          let outputData = {}
          Object.values(finalData).map((o, idx) => {
            // console.log(fareArray[idx], o['requestID'])
            outputData[o['requestID']] = {
              ...o,
              'transportFare': `${fareArray[idx]}`
            }
          })
          // console.log(finalData)
          console.log(outputData)
          if (viewAllWageSheetByDate) {
            viewAllWageSheetByDate.map((newData) => {
              if (Number.isFinite(parseInt(newData['requestID']))) {
                // console.log(newData['transportFare'])
                if (newData['transportFare'] == 0) {
                  outputData[newData['requestID']] = {
                    ...outputData[newData['requestID']],
                    sumWage: newData['wage'],
                    sumWageBaht: newData['wageBaht'],
                    sumExtraWage: outputData[newData['requestID']]['sumExtraWage'],
                    transportFare: newData['transportFare'],
                  }
                } else {
                  outputData[newData['requestID']] = {
                    ...outputData[newData['requestID']],
                    sumWage: newData['wage'],
                    sumWageBaht: newData['wageBaht'],
                    sumExtraWage: outputData[newData['requestID']]['sumExtraWage'],
                    // transportFare: data['transportFare'],
                  }
                }
              }
            })
          }
          console.log(outputData)

          viewAllOfficer = Object.values(viewAllOfficer)
          // console.log(finalData)
          // console.log(finalData)
          // newFinalData.sort((a,b)=>a['jobID'] - b['jobID'])
          // newFinalData = {...newFinalData}
          // console.log(newFinalData)
          this.setState({
            ...this.state,
            data: outputData,
            renderData: outputData,
            inCompleteLoading: false,
            officerData: viewAllOfficer,
            viewAllSurveyPromise: viewAllSurveyPromise
          })
        })


      })
  }
  calculateWageBaht(ton) {
    if (!Number.isNaN(parseFloat(ton))) {
      if (parseFloat(ton) > 100) {
        return ton
      } else {
        return '100.00'
      }
    } else {
      return 0
    }
  }
  setDefaultTransportFare() {
    let viewAllSurveyPromise = this.state.viewAllSurveyPromise

    let finalData = this.state.renderData

    Object.values(finalData).map((data) => {
      let isFoundSurvey = Object.values(viewAllSurveyPromise).filter(o => {
        let isFound = 0
        if (o['companyTaxID']) {
          let findCompany = o['companyTaxID'].filter(oo => oo.companyTax == data['companyTaxID'])
          if (findCompany.length > 0) {
            isFound = 1
          }
        }
        if ((o['surveyNameTH'] == data['surveyLocateName']) && (isFound > 0)) {
          return true
        }
      })
      if (isFoundSurvey.length > 0) {

        let transportFare = isFoundSurvey[0]['companyTaxID'].filter(o => o['companyTax'] == data['companyTaxID'])
        if (transportFare[0]['fare'].length > 0) {
          data['transportFare'] = parseInt(transportFare[0]['fare'])
        } else {
          data['transportFare'] = 0
        }
      } else {
        data['transportFare'] = 0
      }
    })
    this.setState({
      ...this.state,
      renderData: finalData,
      data: finalData
    })
  }
  renderChain(chainID) {
    if (chainID == 'none') {
      return ''
    } else if (chainID == 'chain' || chainID == 'ต่อ' || chainID == 'งานต่อ') {
      return <p style={{ backgroundColor: 'lightgreen' }}>งานต่อ</p>
    } else if (chainID == 'cancleloading' || chainID == 'งดบรรทุก') {
      return <p style={{ backgroundColor: 'lightgreen' }}>งดบรรทุก</p>
    } else if (chainID == 'extraround' || chainID == 'นอกรอบ') {
      return <p style={{ backgroundColor: 'lightgreen' }}>นอกรอบ</p>
    } else if (chainID == 'controlloading' || chainID == 'คุมขนถ่าย') {
      return <p style={{ backgroundColor: 'lightgreen' }}>คุมขนถ่าย</p>
    } else if (chainID == 'cancel' || chainID == 'ยกเลิกงาน') {
      return <p style={{ backgroundColor: '' }}>ยกเลิกงาน</p>
    } else if (chainID == 'blank') {
      return <p style={{ backgroundColor: '' }}></p>
    }
    else {
      return chainID
    }
  }
  excelRenderChain(chainID) {
    if (chainID == 'none') {
      return ''
    } else if (chainID == 'chain' || chainID == 'ต่อ' || chainID == 'งานต่อ') {
      return 'งานต่อ'
    } else if (chainID == 'cancleloading' || chainID == 'งดบรรทุก') {
      return 'งดบรรทุก'
    } else if (chainID == 'extraround' || chainID == 'นอกรอบ') {
      return 'นอกรอบ'
    } else if (chainID == 'controlloading' || chainID == 'คุมขนถ่าย') {
      return 'คุมขนถ่าย'
    } else if (chainID == 'cancel' || chainID == 'ยกเลิกงาน') {
      return 'ยกเลิกงาน'
    } else if (chainID == 'blank') {
      return ''
    }
    else {
      return chainID
    }
  }

  handleFilterChecker(name) {
    let data = this.state.data
    let officerData = this.state.officerData
    if (name == 'full') {
      this.setState({
        ...this.state,
        renderData: this.state.data
      })
    } else {
      if (officerData.filter((o, idx) => `${idx + 1}. ${o['fName']}` == name).length > 0) {
        let isFoundData = Object.values(data).filter(o => o['officerID'] == name)
        if (isFoundData.length > 0) {
          let newObject = {}
          isFoundData.map((data) => {
            newObject[data['requestID']] = data
          })
          this.setState({
            ...this.state,
            renderData: newObject
          })
        } else {
          alert(`ไม่พบงานสำหรับ Checker ${name}`)
          this.setState({
            ...this.state,
            renderData: this.state.data
          })
        }
      } else {
        alert(`ไม่พบงานสำหรับ Checker ${name}`)
        this.setState({
          ...this.state,
          renderData: this.state.data
        })
      }
    }
  }
  exportExcel(renderData) {
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"
    let ws_data = [['วันที่', 'Job', 'รหัสบริษัท', 'ชื่อบริษัท', 'ชื่อ Checker', 'เพิ่มเติม', 'เริ่ม', 'สิ้นสุด'
      , 'จำนวนแรง', 'ค่าแรง(บาท)', 'ล่วงเวลา', 'ค่าพาหนะ', 'ปริมาณ / ตัน']]

    if (Object.values(renderData).length > 0) {
      Object.values(renderData).map((data) => {
        try {
          let dataArr = []
          let chainDetail = 'ไม่มีใบ Checkweight'

          let roundNumber = parseFloat(data['quantity'])
          roundNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)
          let roundNumberWithComma = addCommaInNumber(roundNumber)

          if (data['officerID'] == 'cancel') {
            chainDetail = 'ยกเลิกงาน'
          }

          if (!Number.isNaN(roundNumber)) {
            // if(chainDetail != ''){ 
            chainDetail = this.excelRenderChain(data['chainID'])
            // console.log(`within ifelse  ${chainDetail}`)
            // }else{
            //   chainDetail = 'ไม่มี Checkweight'
            // }
            roundNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)
            roundNumberWithComma = addCommaInNumber(roundNumber)
          }
          if (data['chainID'] != 'none') {
            chainDetail = this.excelRenderChain(data['chainID'])
          }



          dataArr.push(data['shippingDate'])
          dataArr.push(data['jobID'])
          dataArr.push(data['companyTaxID'])
          dataArr.push(data['companyID'])
          dataArr.push(data['officerID'])
          dataArr.push(chainDetail)

          dataArr.push(data['Time']?.split('-')[0])
          dataArr.push(data['Time']?.split('-')[1])
          dataArr.push(data['sumWage'])
          dataArr.push(data['sumWageBaht'])
          dataArr.push(data['sumExtraWage'])
          dataArr.push(data['transportFare'])
          dataArr.push(roundNumberWithComma)
          ws_data.push(dataArr)
        } catch (error) { }
      })
    }

    var ws = XLSX.utils.aoa_to_sheet(ws_data)
    XLSX.utils.book_append_sheet(wb, ws, ws_name)
    XLSX.writeFile(wb, `สรุปค่าแรงรายวัน.xlsx`)

  }
  calculateSumWage(renderData) {
    let wage = 0
    Object.values(renderData).map((data, idx) => {
      // console.log(data['sumWageBaht'],data['sumWage'],idx,data['jobID'])
      if (data['sumWage']) {
        wage += parseInt(data['sumWage'])
      } else {
        if (data['Time'].split('-')[0] == data['Time'].split('-')[1]) {
          wage += 0
        } else {
          if (Number.isNaN(parseInt(this.calculateWage(data['Time']?.split('-')[0], data['Time']?.split('-')[1], data['chainID'])))) {
            wage += 0
          } else {
            wage += parseInt(this.calculateWage(data['Time']?.split('-')[0], data['Time']?.split('-')[1], data['chainID']))
          }
        }
      }
    })
    return wage
  }
  calculateSumWageBaht(renderData) {
    let wage = 0
    Object.values(renderData).map((data) => {
      if (data['sumWageBaht']) {
        let roundNumber = parseFloat(data['sumWageBaht'])
        roundNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)
        wage += parseFloat(roundNumber)
      } else {
        let roundNumber = parseFloat(data['quantity'])
        roundNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)
        wage += parseFloat(this.calculateWageBaht(roundNumber))
      }

      if (data['officerID2'] != '-' && data['officerID2'] != '') {
        if (data['sumWageBaht']) {
          let roundNumber = parseFloat(data['sumWageBaht'])
          roundNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)
          wage += parseFloat(roundNumber)
        } else {
          let roundNumber = parseFloat(data['quantity'])
          roundNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)
          wage += parseFloat(this.calculateWageBaht(roundNumber))
        }
      }

    })
    return wage.toFixed(2)
  }
  calculateSumExtraWage(renderData) {
    let wage = 0
    Object.values(renderData).map((data) => {
      // console.log(data)
      // let isHoliday = false
      // if (new Date(data['shippingDate']).getDay() == 0 || new Date(data['shippingDate']).getDay() == 6) {
      //   isHoliday = true
      // }
      // console.log(data['Time'])
      // let extraWage = parseInt(this.calculateExtraWage(data['Time'].split('-')[0], data['Time'].split('-')[1], data['chainID'], isHoliday))
      // console.log(extraWage)
      let extraWage = data['sumExtraWage']
      if(Number.isNaN(extraWage)) {
        wage += 0
      } else {
        wage += extraWage
      }
    })
    return wage
  }
  calculateSumTransportFare(renderData) {
    let transportFare = 0
    let rawSurveyFare = this.state.viewAllSurveyPromise
    let surveyFare = Object.values(rawSurveyFare).filter(o => o?.fare)
    Object.values(renderData).map((data) => {
      // let isFoundSurvey = surveyFare.filter(o => o['surveyNameTH'] == data['surveyLocateName']) 
      // if(isFoundSurvey.length > 0){
      //   transportFare += parseInt(isFoundSurvey[0]['fare'])
      // }
      if (Number.isNaN(data['transportFare'])) {
        transportFare += 0
      } else {
        transportFare += parseFloat(data['transportFare'])
      }
    })
    return transportFare
  }
  calculateSumQuantity(renderData) {
    let totalQuantity = 0
    Object.values(renderData).map((data) => {
      if (Number.isNaN(parseFloat(data['quantity']))) {
        totalQuantity += 0
      } else {

        // totalQuantity += parseFloat(data['transportFare'])
        let roundNumber = parseFloat(data['quantity'])
        roundNumber = (Math.round((roundNumber + Number.EPSILON) * 100) / 100)
        totalQuantity += roundNumber
        if (data['isExtraCertificate']) {
          data['extraCertificate'].map((extraData) => {
            if (Number.isNaN(parseFloat(extraData['value']))) {
              totalQuantity += 0
            } else {
              let newRoundNumber = parseFloat(extraData['value'])
              newRoundNumber = (Math.round((newRoundNumber + Number.EPSILON) * 100) / 100)
              totalQuantity += newRoundNumber
            }
          })
        }
      }
    })
    return totalQuantity.toFixed(2)
  }
  handleChangeTime(jobID, e) {
    let isFoundData = Object.values(this.state.data).filter(o => o.jobID == jobID)
    if (isFoundData.length != 0) {
      let singleData = isFoundData[0]
      let indexObj = singleData['requestID']
      // e.target.value
      // e.target.id 

      let id = e.target.id
      let value = e.target.value

      let timeArray = singleData['Time'].split('-')
      // console.log(timeArray,id,value)

      if (id == 'startTime') {
        timeArray[0] = e.target.value
      }
      if (id == 'endTime') {
        timeArray[1] = e.target.value
      }

      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          [indexObj]: {
            ...this.state.data[indexObj],
            ['Time']: `${timeArray[0]}-${timeArray[1]}`
          }
        },
        renderData: {
          ...this.state.renderData,
          [indexObj]: {
            ...this.state.renderData[indexObj],
            ['Time']: `${timeArray[0]}-${timeArray[1]}`
          }
        }
      })
    } else {
      alert(`ไม่สามารถแก้ไขข้อมูลได้ code:${jobID},${e.target.id},${e.target.value}`)
    }
  }

  handleChangeValue(jobID, e) {
    let isFoundData = Object.values(this.state.data).filter(o => o.jobID == jobID)
    if (isFoundData.length != 0) {
      let singleData = isFoundData[0]
      let indexObj = singleData['requestID']
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          [indexObj]: {
            ...this.state.data[indexObj],
            [e.target.id]: e.target.value
          }
        },
        renderData: {
          ...this.state.renderData,
          [indexObj]: {
            ...this.state.renderData[indexObj],
            [e.target.id]: e.target.value
          }
        }
      })
    } else {
      alert(`ไม่สามารถแก้ไขข้อมูลได้ code:${jobID},${e.target.id},${e.target.value}`)
    }
  }
  handleSaveData(data) {
    let postData = []
    Object.values(data).map((singleData) => {
      let roundNumber = parseFloat(singleData['quantity'])
      roundNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)
      let roundNumberWithComma = addCommaInNumber(roundNumber)

      postData.push({
        requestID: singleData['requestID'],
        officerID: singleData['officerID'],
        officerID2: singleData['officerID2'],
        chainID: singleData['chainID'],
        jobID: singleData['jobID'],
        wage: singleData['sumWage'],
        wageBaht: singleData['sumWageBaht'],
        extraWage: singleData['sumExtraWage'],
        transportFare: singleData['transportFare'],
        shippingDate: singleData['shippingDate'],
        companyTaxID: singleData['companyTaxID'],
        ton: roundNumberWithComma
      })
    })
    axios.post(
      'https://backend1.riceinspections.com/testIA',
      {
        data: { 'arr': [...new Set(postData)] },
      })
  }
  renderExtraCertificate(data, idx) {
    if (data['isExtraCertificate']) {
      return <a href="javascript:void(0)" onClick={() => { this.handleModal(data['extraCertificate'], idx) }}> แก้ไข </a>
    } else {
      return ''
    }
  }
  handleModal(extraCertificate, idx) {
    if (Array.isArray(extraCertificate)) {
      this.setState({
        ...this.state,
        modalExtracertificate: !this.state.modalExtracertificate,
        modalExtracertificateData: extraCertificate,
        modalIndex: idx
      })
    } else {
      return ''
    }
  }
  toggleModal() {
    this.setState({
      ...this.state,
      modalExtracertificate: !this.state.modalExtracertificate,
    })
  }
  handleExtraCertificateValue(e, idx, idz) {
    let newRenderData = this.state.renderData
    if (Number.isNaN(parseFloat(e.target.value))) {
      Object.values(newRenderData)[idx]['extraCertificate'][idz]['value'] = ''
    } else {
      Object.values(newRenderData)[idx]['extraCertificate'][idz]['value'] = e.target.value
    }

    this.setState({
      ...this.state,
      // renderData : newRenderData
    })
  }
  renderTableExtraCertificate(extraCertificate, idx) {
    if (Array.isArray(extraCertificate) && idx != '-99') {
      let divArr = []
      extraCertificate.map((data, idz) => {
        divArr.push(<tr>
          <td>{data['description']}</td>
          <td><input id={idx} value={data['value']} onChange={(e) => { this.handleExtraCertificateValue(e, idx, idz) }}></input></td>
        </tr>)
      })
      return divArr
    } else {
      return ''
    }
  }
  checkWeightIsComplete(des) {
    let checkIsCompleteArr = []

    des.map((desIte) => {
      if (Object.keys(desIte).indexOf('isComplete') == -1) {
        checkIsCompleteArr.push(0)
      }
    })
    // console.log(checkIsCompleteArr)
    if (checkIsCompleteArr.length == des.length) {
      return ''
    }
  }
  render() {
    if (!this.state.inCompleteLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <div style={{ width: '100%', alignContent: 'center', textAlign: 'center', fontSize: '22px' }}  >
            <p><b>ค่าแรง ประจำวันที่ {this.renderDate(this.props.history.location.state.startDate)}</b></p>
          </div>
          <div> ค้นหา Checker
            <select onChange={(e) => { this.handleFilterChecker(e.target.value) }}>
              <option value='full' > กรุณาเลือกชื่อ Checker </option>
              {(() => {
                return this.state.officerData.map((officerData, index) => {
                  return <option value={`${index + 1}. ${officerData['fName']}`} > {`${index + 1}. ${officerData['fName']}`} </option>
                })
              })()}
            </select>
            &nbsp;&nbsp;&nbsp;
            <Button onClick={() => { this.handleSaveData(this.state.data) }}>บันทึกข้อมูล</Button>
            &nbsp;&nbsp;&nbsp;
            <Button onClick={() => { this.exportExcel(this.state.renderData) }}> Download Excel </Button>
          </div>
          <Table bordered hover style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>

                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>วันที่</th>
                <th style={{ width: '2.%', overflow: 'auto', fontSize: '11px' }}>Job</th>
                <th style={{ width: '5.5%', overflow: 'auto', fontSize: '11px' }}>รหัสบริษัท</th>
                <th style={{ width: '4.7%', overflow: 'auto', fontSize: '11px' }}>ชื่อบริษัท</th>
                <th style={{ width: '4.7%', overflow: 'auto', fontSize: '11px' }}>ชื่อ Checker</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>เพิ่มเติม</th>
                <th style={{ width: '3.2%', overflow: 'auto', fontSize: '11px' }}>เริ่ม</th>
                <th style={{ width: '3.2%', overflow: 'auto', fontSize: '11px' }}>สิ้นสุด</th>
                <th style={{ width: '3.2%', overflow: 'auto', fontSize: '11px' }}>จำนวนแรง</th>
                <th style={{ width: '3.2%', overflow: 'auto', fontSize: '11px' }}>ค่าแรง(บาท)</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>ล่วงเวลา</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>ค่าพาหนะ <br /> <a style={{ color: 'blue' }} href='javascript:void(0)' onClick={this.setDefaultTransportFare}>คืนค่า</a> </th>
                <th style={{ width: '4.2%', overflow: 'auto', fontSize: '11px' }}>ปริมาณ / ตัน</th>
              </tr>
            </thead>
            <tbody style={{ width: '100%' }}>
              {(() => {
                if (Object.values(this.state.renderData).length > 0) {
                  return (Object.values(this.state.renderData).map((data, idx) => {
                    if (data && data['chainID'] != 'blank') {
                      let roundNumber = parseFloat(data['quantity'])
                      let roundNumberWithComma = '0.00'
                      let chainDetail = 'ไม่มี Checkweight'
                      if(data['checkWeightID'] =="72270"){
                        console.log(data)
                      }
                      // chainDetail = this.renderChain(data['chainID'])
                      // chainDetail = this.checkWeightIsComplete(data['description'])
                      if (data['officerID'] == 'cancel') {
                        chainDetail = 'ยกเลิกงาน'
                      }

                      if (data['isExtraCertificate']) {
                        data['extraCertificate'].map((data) => {
                          // console.log(parseFloat(data['value']))
                          if (Number.isNaN(parseFloat(data['value']))) {
                            roundNumber += 0
                          } else {
                            roundNumber += parseFloat(data['value'])
                          }
                        })
                      }
                      if (!Number.isNaN(roundNumber) && roundNumber > 0) {
                        // if(chainDetail != ''){
                        chainDetail = this.renderChain(data['chainID'])
                        // }else{
                        //   chainDetail = 'ไม่มี Checkweight'
                        // }

                        let roundedNumber = ((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)
                        // console.log(roundedNumber,((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(4),idx)
                        roundNumberWithComma = addCommaInNumber(roundedNumber)
                      }
                      if (data['chainID'] != 'none') {
                        chainDetail = this.renderChain(data['chainID'])
                      }
                      if (data['officerID2'] != '-' && data['officerID2'] != '') {
                        let a = []
                        a.push(<tr >
                          <td style={{ width: '7.7%', fontSize: '13px' }}><b>{this.renderDate(data['shippingDate'])}</b></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><b>{data['jobID']}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b >{`0${data['companyTaxID'] ?? 0}`}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{data['companyID']}</b></td>
                          <td style={{ width: '7.7%', fontSize: '13px' }}><b>{data['officerID']} </b></td>
                          <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b>{chainDetail}</b></td>
                          <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b>{<input value={data['Time']?.split('-')[0]}></input>}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{<input value={data['Time']?.split('-')[1]}></input>}</b></td>
                          <td style={{ width: '2.7%', overflow: '2.7%', fontSize: '13px' }}><b><input id='sumWage' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumWage']}></input></b></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='sumWageBaht' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumWageBaht']}></input></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='sumExtraWage' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumExtraWage']}></input></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='transportFare' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['transportFare']}></input></td>
                          <td style={{ width: '7.7%', fontSize: '13px', textAlign: 'right' }} ><b>{roundNumberWithComma}</b> <br /> {this.renderExtraCertificate(data, idx)} </td>
                        </tr>)
                        a.push(<tr >
                          <td style={{ width: '7.7%', fontSize: '13px' }}><b>{this.renderDate(data['shippingDate'])}</b></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><b>{data['jobID']}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b >{`0${data['companyTaxID'] ?? 0}`}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{data['companyID']}</b></td>
                          <td style={{ width: '7.7%', fontSize: '13px' }}><b>{data['officerID2']} </b></td>
                          <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b>{chainDetail}</b></td>
                          <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b>{<input value={data['Time']?.split('-')[0]}></input>}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{<input value={data['Time']?.split('-')[1]}></input>}</b></td>
                          <td style={{ width: '2.7%', overflow: '2.7%', fontSize: '13px' }}><b><input id='sumWage' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumWage']}></input></b></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='sumWageBaht' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumWageBaht']}></input></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='sumExtraWage' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumExtraWage']}></input></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='transportFare' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['transportFare']}></input></td>
                          <td style={{ width: '7.7%', fontSize: '13px', textAlign: 'right' }} ><b>-</b> <br />  </td>
                        </tr>)
                        return a
                      } else {

                        return (<tr >
                          <td style={{ width: '7.7%', fontSize: '13px' }}><b>{this.renderDate(data['shippingDate'])}</b></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><b>{data['jobID']}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b >{`0${data['companyTaxID'] ?? 0}`}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{data['companyID']}</b></td>
                          <td style={{ width: '7.7%', fontSize: '13px' }}><b>{data['officerID']} {data['officerID2'] != '-' ? data['officerID2'] : ''} </b></td>
                          <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b>{chainDetail}</b></td>
                          <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b>{<input id='startTime' onChange={(e) => { this.handleChangeTime(data['jobID'], e) }} style={{ width: '100%' }} value={data['Time']?.split('-')[0]}></input>}</b></td>
                          <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{<input id='endTime' onChange={(e) => { this.handleChangeTime(data['jobID'], e) }} style={{ width: '100%' }} value={data['Time']?.split('-')[1]}></input>}</b></td>
                          <td style={{ width: '2.7%', overflow: '2.7%', fontSize: '13px' }}><b><input id='sumWage' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumWage']}></input></b></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='sumWageBaht' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumWageBaht']}></input></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='sumExtraWage' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['sumExtraWage']}></input></td>
                          <td style={{ width: '2.7%', fontSize: '13px' }}><input id='transportFare' onChange={(e) => { this.handleChangeValue(data['jobID'], e) }} style={{ width: '100%' }} value={data['transportFare']}></input></td>
                          <td style={{ width: '7.7%', fontSize: '13px', textAlign: 'right' }} ><b>{roundNumberWithComma}</b> <br /> {this.renderExtraCertificate(data, idx)} </td>
                        </tr>)
                      }
                    }

                  }))
                }
              })()}
              {(() => {

                return (<tr >
                  <td style={{ width: '7.7%', fontSize: '13px' }}><b>{ }</b></td>
                  <td style={{ width: '2.7%', fontSize: '13px' }}><b>{ }</b></td>
                  <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b >{ }</b></td>
                  <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{ }</b></td>
                  <td style={{ width: '7.7%', fontSize: '13px' }}></td>
                  <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b></b></td>
                  <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{ }</b></td>
                  <td style={{ width: '2.7%', overflow: '2.7%', fontSize: '13px' }}>{ }</td>
                  <td style={{ width: '2.7%', fontSize: '13px' }}>{this.calculateSumWage(this.state.renderData)}</td>
                  <td style={{ width: '2.7%', fontSize: '13px' }}>{addCommaInNumber(this.calculateSumWageBaht(this.state.renderData))}</td>
                  <td style={{ width: '2.7%', fontSize: '13px' }}>{addCommaInNumber(this.calculateSumExtraWage(this.state.renderData))}</td>
                  <td style={{ width: '7.7%', fontSize: '13px', textAlign: 'right' }} ><b>{addCommaInNumber(this.calculateSumTransportFare(this.state.renderData))}</b> <br /> </td>
                  <td style={{ width: '7.7%', fontSize: '13px', textAlign: 'right' }} ><b>{addCommaInNumber(this.calculateSumQuantity(this.state.renderData))}</b> <br /> </td>
                </tr>)
              })()}
            </tbody>
          </Table>

          <Modal show={this.state.modalExtracertificate} onHide={() => { }} onClick={() => { }} centered>
            <Modal.Header onClick={() => { this.toggleModal() }} closeButton>
              <Modal.Title> รายละเอียด </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Table bordered hover style={{ tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                    <th style={{ overflow: 'auto', fontSize: '11px' }}>รายละเอียด </th>
                    <th style={{ overflow: 'auto', fontSize: '11px' }}>จำนวนตัน</th>
                  </tr>
                </thead>
                <tbody >
                  {this.renderTableExtraCertificate(this.state.modalExtracertificateData, this.state.modalIndex)}
                </tbody>
              </Table>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => { this.toggleModal() }}>ยืนยัน</Button>
            </Modal.Footer>
          </Modal>
        </Container>
      )
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>)
    }
  }
}

export default withRouter(FinancialWageTable);